import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { Hammer, AlertTriangle, FileDown, ExternalLink } from "lucide-react";

export default function WorkOrders() {
  const [orders, setOrders] = useState([]);
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/work-orders").then((r) => setOrders(r.data)),
      api.get("/teams").then((r) => setTeams(r.data)),
    ]).catch(() => {});
  }, []);

  const teamName = (id) => teams.find((t) => t.id === id)?.name || "—";
  const downloadPdf = (fileId) => {
    const token = localStorage.getItem("opscmd_token");
    window.open(`${API}/files/${fileId}?auth=${encodeURIComponent(token || "")}`, "_blank");
  };

  return (
    <div className="p-6 lg:p-8 space-y-4">
      <div className="bg-white border border-[#1a1a1a]/15 p-5 flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#ff4500] text-white flex items-center justify-center">
            <Hammer className="w-5 h-5" />
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#ff4500]">// Cross-team</div>
            <div className="font-display font-black text-xl">Work orders</div>
          </div>
        </div>
        <div className="text-[11px] font-mono text-[#1a1a1a]/60 uppercase tracking-wider">{orders.length} total</div>
      </div>

      <div className="bg-white border border-[#1a1a1a]/15">
        <div className="grid grid-cols-[2fr_1fr_1fr_0.7fr_auto] gap-3 px-4 py-3 bg-[#1a1a1a] text-white text-[10px] uppercase tracking-[0.18em] font-bold">
          <div>Title</div><div>From</div><div>To team</div><div>Type</div><div></div>
        </div>
        {orders.length === 0 && (
          <div className="hatched py-12 text-center text-[12px] font-mono uppercase tracking-wider text-[#1a1a1a]/60">
            No work orders yet. Distribute an audit to send one.
          </div>
        )}
        {orders.map((o) => (
          <div key={o.id} className="grid grid-cols-[2fr_1fr_1fr_0.7fr_auto] gap-3 px-4 py-3 border-b border-[#1a1a1a]/10 items-center hover:bg-[#f0ede6] transition-colors duration-150">
            <div>
              <div className="font-display font-bold text-sm flex items-center gap-2">
                {o.request_type === "quality_issue" && <AlertTriangle className="w-3.5 h-3.5 text-[#ff4500]" />}
                {o.title}
              </div>
              {o.notes && <div className="text-[11px] text-[#1a1a1a]/70 mt-0.5 truncate">{o.notes}</div>}
            </div>
            <div className="text-sm">{o.from_user_name}</div>
            <div className="text-sm">{teamName(o.to_team_id)}</div>
            <div>
              <span className={`text-[10px] uppercase tracking-wider font-bold px-2 py-0.5 ${o.request_type === "quality_issue" ? "bg-[#ff4500] text-white" : "bg-[#1a1a1a] text-white"}`}>
                {o.request_type}
              </span>
            </div>
            <div className="flex items-center gap-2">
              {o.pdf_file_id && (
                <button data-testid={`wo-pdf-${o.id}`} onClick={() => downloadPdf(o.pdf_file_id)}
                  className="text-[#1a1a1a] hover:text-[#ff4500] inline-flex items-center gap-1 text-[11px] uppercase tracking-wider font-bold">
                  <FileDown className="w-3.5 h-3.5" /> PDF
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
